import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { TApkType, IApkByIDsRestaurantsForApk } from 'types';
import { allApkTypes } from 'appConstants';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import classNames from 'classnames';
import style from './Apk.module.scss';

interface IApk {
	data: IApkByIDsRestaurantsForApk[];
	restaurantID: string;
}

const Apk: React.FC<IApk> = ({ data, restaurantID }) => {
	const { deleteApkFromRestaurant } = useContext<IApkAssignmentContext>(ApkAssignmentContext);

	const getApkTypeName = (apkType: TApkType) =>
		allApkTypes.find((el) => el.apkTypeID === apkType)?.apkTypeName || null;
	const apkTypeName = useMemo(() => getApkTypeName, []);

	return (
		<div data-test="Apk">
			{data.map((el) => {
				const containerClasses = classNames(style.container, { [style.addedItem]: !el.versionName });

				return (
					<div className={containerClasses} key={el.tabletAppId + 'apkTab'}>
						<Text className={style.name} translationKey={el.versionName} withTooltip={true} />
						<Text className={style.type} translationKey={apkTypeName(el.type)} withTooltip={true} />
						<svg
							className={style.closeIcon}
							onClick={() => deleteApkFromRestaurant(restaurantID, el.tabletAppId)}>
							<use xlinkHref={`${breadcrumbs}#close`} />
						</svg>
					</div>
				);
			})}
		</div>
	);
};

export default Apk;
